import React, { useState, useEffect } from "react";
import { Spin } from "antd";
import { ErrorMessage, Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import {
  Accordion,
  Button,
  Col,
  Form,
  Modal,
  OverlayTrigger,
  Row,
  Tooltip,
} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { SVGICON } from "../../../constant/theme";

import CustomSizePerPage from "../../../CustomControls/CustomSizePerPage";
import CustomPaginationButtons from "../../../CustomControls/CustomPaginationButtons";
import { post, postFormData } from "../../../helpers/api_helper";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomSelect from "../../../CustomControls/CustomSelect";
import CustomFlatpickr from "../../../CustomControls/CustomFlatpickr";

import {
  cleanCsvString,
  delete_Record,
  delete_RecordWithoutApi,
  errorMessage,
  infoMessage,
  successMessage,
  validateEmail,
  validateMobileNoField,
  warningMessage,
} from "../CommonFunctions";
import {
  POST_ControlCenterScanCopyEmailSend,
  POST_GetControlCenterScanCopyEmailDetailList,
  POST_GetCustomerContactPersonDDL,
  POST_GetCustomerDDLList,
  POST_GetCustomerDDLListAJAX,
  POST_GetUploadScanCopiesList,
  POST_GetUploadScanCopyAdditionalDocumentsDetailByID,
  POST_UploadScanCopiesDelete,
  POST_UploadScanCopiesWhatsAppMessageSend,
  POST_UploadScanCopyAdditionalDocumentsSave,
} from "../../../helpers/url_helper";
import moment from "moment";
import { useFilter } from "../../../../context/FilterContext";
import CustomSelectAsync from "../../../CustomControls/CustomSelectAsync";

const UploadScanCopy = () => {
  const { filter, updateFilter } = useFilter();

  const [showFilter, setShowFilter] = useState(false);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(
    filter && filter?.page == "upload-scan-copy" ? filter?.CurrentPage : 1
  );
  const [currentSizePerPage, setCurrentSizePerPage] = useState(
    filter && filter?.page == "upload-scan-copy" ? filter?.PageSize : 10
  );
  const [recordCount, setRecordCount] = useState(0);

  const [sortBy, setSortBy] = useState(
    filter && filter?.page == "upload-scan-copy" ? filter?.sortBy : ""
  );
  const [orderBy, setOrderBy] = useState(
    filter && filter?.page == "upload-scan-copy" ? filter?.orderBy : "asc"
  );

  const [isReset, setIsReset] = useState(false);

  const [uploadScanCopyList, setUploadScanCopyList] = useState([]);
  const [customerOptionList, setCustomerList] = useState([]);

  const [showUploadAdditionalDocModel, setShowUploadAdditionalDocModel] =
    useState(false);

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const formsList = AuthUser?.Permissions?.FormList;

  const handleClickSorting = (columnName) => {
    setCurrentPage(1);
    if (sortBy == columnName) {
      if (orderBy == "asc") {
        setOrderBy("desc");
      } else {
        setSortBy("");
        setOrderBy("asc");
      }
    } else {
      setSortBy(columnName);
      setOrderBy("asc");
    }
  };

  const mailSentOptions = [
    { label: "All", value: -1 },
    { label: "Yes", value: 1 },
    { label: "No", value: 0 },
  ];

  const validationSchema = Yup.object().shape({});

  const formikFilter = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      TCNo: filter && filter?.page == "upload-scan-copy" ? filter?.TCNo : "",
      InwardNo:
        filter && filter?.page == "upload-scan-copy" ? filter?.InwardNo : "",
      FromDate:
        filter && filter?.page == "upload-scan-copy"
          ? filter?.FromDate
          : new Date(),
      ToDate:
        filter && filter?.page == "upload-scan-copy"
          ? filter?.ToDate
          : new Date(),
      CustomerID:
        filter && filter?.page == "upload-scan-copy" ? filter?.CustomerID : "",
      SampleDetail:
        filter && filter?.page == "upload-scan-copy"
          ? filter?.SampleDetail
          : "",
      ScanBarcode:
        filter && filter?.page == "upload-scan-copy" ? filter?.ScanBarcode : "",
      MailSent:
        filter && filter?.page == "upload-scan-copy" ? filter?.MailSent : -1,
      Search:
        filter && filter?.page == "upload-scan-copy" ? filter?.Search : "",
    },
    validateOnBlur: false,
  });

  const {
    handleValidSubmit,
    values: {
      TCNo,
      FromDate,
      ToDate,
      InwardNo,
      CustomerID,
      MailSent,
      SampleDetail,
      ScanBarcode,
      Search,
    },
  } = formikFilter;

  useEffect(() => {
    if (ToDate && ToDate < FromDate) {
      formikFilter.setFieldValue("ToDate", FromDate);
    }
  }, [FromDate]);

  const getResetData = async () => {
    setIsLoading(true);

    // formikFilter.resetForm();
    formikFilter.setValues({
      TCNo: "",
      InwardNo: "",
      FromDate: new Date(),
      ToDate: new Date(),
      CustomerID: "",
      SampleDetail: "",
      ScanBarcode: "",
      MailSent: -1,
      Search: "",
    });

    setCurrentPage(1);
    setSortBy("");
    setOrderBy("asc");

    setIsReset(true);
  };

  const fnCallback = () => {
    getData(currentPage, currentSizePerPage);
  };

  const getData = async (page = 1, sizePerPage = 10) => {
    setIsLoading(true);

    updateFilter({
      page: "upload-scan-copy",
      CurrentPage: page,
      PageSize: sizePerPage,
      sortBy: sortBy,
      orderBy: orderBy,
      FromDate: FromDate ? FromDate : "",
      ToDate: ToDate ? ToDate : "",
      TCNo: TCNo,
      InwardNo: InwardNo,
      CustomerID: CustomerID,
      SampleDetail: SampleDetail,
      ScanBarcode: ScanBarcode,
      MailSent: MailSent,
      Search: Search,
    });

    let payload = {
      CurrentPage: page,
      PageSize: sizePerPage,
      Search: Search,
      Sorting: sortBy ? sortBy + " " + orderBy : "",
      TCNo: TCNo,
      InwardNo: InwardNo,
      // FromDate: FromDate ? moment(FromDate).format("DD-MMM-yyyy") : "",
      // ToDate: ToDate ? moment(ToDate).format("DD-MMM-yyyy") : "",
      FromDate: FromDate
        ? moment(FromDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      ToDate: ToDate
        ? moment(ToDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      CustomerIDEncrypted: CustomerID,
      MailSent: MailSent,
      SampleDetail: SampleDetail,
      ScanBarcode: ScanBarcode,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    };
    await post(POST_GetUploadScanCopiesList, payload)
      .then((response) => {
        setRecordCount(response?.TotalRecordCount);
        setUploadScanCopyList(response?.ListOfUploadScanCopies);
        setIsLoading(false);
        if (page > 1 && response?.ListOfUploadScanCopies?.length === 0) {
          setCurrentPage(page - 1);
          getData(page - 1, sizePerPage);
        } else {
          setCurrentPage(page);
        }
        setCurrentSizePerPage(sizePerPage);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getCustomerDDL();
  }, []);

  useEffect(() => {
    getData(currentPage, currentSizePerPage);
  }, [sortBy, orderBy]);

  useEffect(() => {
    if (isReset == true) {
      getData(currentPage, currentSizePerPage);
      setIsReset(false);
    }
  }, [isReset]);

  const getCustomerDDL = async () => {
    setIsLoading(true);
    await post(POST_GetCustomerDDLList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      TPIFlag: -1, // -1 = All (Customer & TPI both)
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setCustomerList(
            response?.CustomerDDLList?.map((item) => ({
              label: item.CustomerName,
              value: item.CustomerIDEncrypted,
            }))
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const addUploadAdditionalDoc = async (UploadScanCopyID) => {
    //alert(UploadScanCopyIDEncrypted);

    setIsLoading(true);
    await post(POST_GetUploadScanCopyAdditionalDocumentsDetailByID, {
      UploadScanCopyIDEncrypted: UploadScanCopyID,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formikUploadAdditionalDoc.setFieldValue(
            "ListOfUploadAdditionalDocFile",
            response?.List?.map((x, indx) => ({
              UploadScanCopyAdditionalDocumentIDEncrypted:
                x?.UploadScanCopyAdditionalDocumentIDEncrypted,
              UploadScanCopyIDEncrypted: x?.UploadScanCopyIDEncrypted,
              InwardMaterialIDEncrypted: x?.InwardMaterialIDEncrypted,
              UploadAdditionalDocFile: "",
              viewUploadAdditionalDocFile: "",
              UploadAdditionalDocFileName: x?.AdditionalDocumentFileName,
              // UploadAdditionalDocFileName: x?.AdditionalDocumentFilePath
              //   ? (x?.AdditionalDocumentFilePath?.split("/"))[
              //       x?.AdditionalDocumentFilePath?.split("/").length - 1
              //     ]
              //   : "",
              UploadAdditionalDocFilePath: x?.AdditionalDocumentFilePath,
              IsDeleted: false,
            }))
          );
        } else {
          formikUploadAdditionalDoc.setFieldValue(
            "ListOfUploadAdditionalDocFile",
            []
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });

    setShowUploadAdditionalDocModel(true);
  };

  const validationSchemaUploadAdditionalDoc = Yup.object().shape({
    // UploadAdditionalDocFile: Yup.string()
    //   .trim()
    //   .required("Upload Additional Doc File is required field"),
  });

  const formikUploadAdditionalDoc = useFormik({
    validationSchema: validationSchemaUploadAdditionalDoc,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitUploadAdditionalDoc(values, formikHelpers),
    initialValues: {
      InwardMaterialIDEncrypt: "",
      UploadAdditionalDocFile: "",
      UploadScanCopyIDEncrypted: "",
      ListOfUploadAdditionalDocFile: [],
    },
    validateOnBlur: false,
  });

  const {
    values: {
      InwardMaterialIDEncrypt,
      UploadScanCopyIDEncrypted,
      UploadAdditionalDocFile,
      ListOfUploadAdditionalDocFile,
    },
  } = formikUploadAdditionalDoc;

  const handleValidSubmitUploadAdditionalDoc = (values) => {
    setIsLoading(true);
    let formData = new FormData();

    formData.append(
      "UploadScanCopyIDEncrypt",
      values?.UploadScanCopyIDEncrypted
    );
    formData.append(
      "InwardMaterialIDEncrypt",
      AuthUser?.InwardMaterialIDEncrypt
    );
    formData.append("BranchIDEncrypt", AuthUser?.BranchIDEncrypt);
    formData.append("CompanyIDEncrypt", AuthUser?.CompanyIDEncrypt);
    formData.append(
      "CreatedByEncrypt",
      AuthUser?.ReferenceIDEncrypt ? AuthUser?.ReferenceIDEncrypt : "0"
    );

    Promise.all(
      values?.ListOfUploadAdditionalDocFile?.map((x, i) => {
        formData.append(
          `ListOfAdditionalDocuments[${i}].UploadScanCopyAdditionalDocumentIDEncrypted`,
          x.UploadScanCopyAdditionalDocumentIDEncrypted
        );
        formData.append(
          `ListOfAdditionalDocuments[${i}].AdditionalDocumentFilePathFile`,
          x.UploadAdditionalDocFile
        );
        formData.append(
          `ListOfAdditionalDocuments[${i}].AdditionalDocumentFilePath`,
          x.UploadAdditionalDocFilePath
        );
        formData.append(
          `ListOfAdditionalDocuments[${i}].IsDeleted`,
          x.IsDeleted
        );
      })
    );

    postFormData(POST_UploadScanCopyAdditionalDocumentsSave, formData)
      .then((response) => {
        if (response?.IsSuccess) {
          successMessage(response?.Message);
          setTimeout(() => {
            navigate("/upload-scan-copy-list");
          }, 1000);
        } else {
          errorMessage(response?.Message);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
    setIsLoading(false);
    setShowUploadAdditionalDocModel(false);
  };

  const uploadAdditionalDocChange = (e) => {
    if (e.target.files[0]) {
      const file = e.target.files[0];
      // //var pattern = [".doc", ".docx", ".pdf"];
      // // var pattern = /(doc|docx|pdf)$/;
      // var pattern = /^application\/(pdf|doc|docx)$/i;
      // if (
      //   !file.type.match("pdf") &&
      //   !file.type.match("doc") &&
      //   !file.type.match("docx")
      // ) {
      //   //if (!file.type.match(pattern)) {
      //   warningMessage("Select valid file!");
      // } else {
      formikUploadAdditionalDoc.setFieldValue("ListOfUploadAdditionalDocFile", [
        ...ListOfUploadAdditionalDocFile,
        {
          UploadScanCopyAdditionalDocumentIDEncrypted: "",
          UploadScanCopyIDEncrypted: "",
          InwardMaterialIDEncrypted: InwardMaterialIDEncrypt,
          UploadAdditionalDocFile: file,
          viewUploadAdditionalDocFile: URL.createObjectURL(file),
          UploadAdditionalDocFileName: file?.name,
          AdditionalDocumentFileName: file?.name,
          UploadAdditionalDocFilePath: "",
          IsDeleted: false,
        },
      ]);
      // }
    }
  };

  const deleteUploadAdditionalDoc = (i) => {
    if (
      ListOfUploadAdditionalDocFile[i]
        ?.UploadScanCopyAdditionalDocumentIDEncrypted
    ) {
      formikUploadAdditionalDoc.setFieldValue(
        `ListOfUploadAdditionalDocFile[${i}].IsDeleted`,
        true
      );
    } else {
      formikUploadAdditionalDoc.setFieldValue(
        "ListOfUploadAdditionalDocFile",
        ListOfUploadAdditionalDocFile?.filter((x, ix) => ix != i)
      );
    }
  };

  const [showSendScanCopyModal, setShowSendScanCopyModal] = useState(false);
  const [sscContactPersonOptions, setsscContactPersonOptions] = useState([]);

  const loadOptionsCustomer_SSC = (inputValue) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(getCustomerDDL_AJAX(inputValue));
      }, 1000);
    });
  };

  const getCustomerDDL_AJAX = (inputValue) => {
    return post(POST_GetCustomerDDLListAJAX, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      SearchValue: inputValue ?? "",
      TPIFlag: -1, // 0 = Only Customer, 1 = Only TPI,  -1 = All (Customer & TPI both)
    })
      .then((response) => {
        if (response?.IsSuccess) {
          return response?.CustomerDDLList?.map((item) => ({
            label: item.CustomerName,
            value: item.CustomerIDEncrypted,
          }));
        } else {
          return [];
        }
      })
      .catch((error) => {
        console.log(error);
        return [];
      });
  };

  const addAdditionalContactPerson_SSC = () => {
    if (sscCustomerIDEncrypted && sscCustomerContactPersonIDEncrypted) {
      if (
        sscListOfAdditionalContactPerson?.filter(
          (x) =>
            x?.CustomerContactPersonIDEncrypted ==
            sscCustomerContactPersonIDEncrypted
        )?.length == 0
      ) {
        formikSendScanCopy.setFieldValue("sscListOfAdditionalContactPerson", [
          ...sscListOfAdditionalContactPerson,
          {
            IsSelected: true,
            CustomerName: sscCustomerName,
            CustomerContactPersonIDEncrypted:
              sscCustomerContactPersonIDEncrypted,
            ContactPerson: sscContactPerson,
            Designation: sscDesignation,
            MobileNo: sscMobileNo,
            EmailID: sscEmailID,
            ContactPersonID: sscContactPersonID,
          },
        ]);
        formikSendScanCopy.setFieldValue(
          "sscCustomerContactPersonIDEncrypted",
          ""
        );
        formikSendScanCopy.setFieldValue("sscContactPerson", "");
        formikSendScanCopy.setFieldValue("sscDesignation", "");
        formikSendScanCopy.setFieldValue("sscMobileNo", "");
        formikSendScanCopy.setFieldValue("sscEmailID", "");
        formikSendScanCopy.setFieldValue("sscContactPersonID", "");
      } else {
        //show duplicate error
        warningMessage("Contact Person already exists!");
      }
    } else {
      if (!sscCustomerIDEncrypted) {
        formikSendScanCopy.setFieldError(
          "sscCustomerIDEncrypted",
          "Customer is required field"
        );
        formikSendScanCopy.setFieldTouched("sscCustomerIDEncrypted", true);
      }
      if (!sscCustomerContactPersonIDEncrypted) {
        formikSendScanCopy.setFieldError(
          "sscCustomerContactPersonIDEncrypted",
          "Contact Person is required field"
        );
        formikSendScanCopy.setFieldTouched(
          "sscCustomerContactPersonIDEncrypted",
          true
        );
      }
    }
  };

  const getCustomerContactPersonDDL_SSC = async (customerID) => {
    setIsLoading(true);
    await post(POST_GetCustomerContactPersonDDL, {
      CustomerIDEncrypted: customerID,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setsscContactPersonOptions(
            response?.ListOfContactPersons?.map((item) => ({
              label: item.ContactPerson,
              value: item.CustomerContactPersonIDEncrypted,
              MobileNo: item.MobileNo,
              EmailID: item.EmailID,
              Designation: item.Designation,
              ContactPersonID: item.ContactPersonID,
            }))
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        isLoading(false);
      });
  };

  const validationSchemaSendScanCopy = Yup.object().shape({});

  const formikSendScanCopy = useFormik({
    validationSchemaSendScanCopy,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitSendScanCopy(values, formikHelpers),
    initialValues: {
      InwardIDEncrypted: "",
      InwardMaterialIDEncrypted: "",
      sscListOfProjectContactPerson: [],
      sscListOfCustomerContactPerson: [],
      sscListOfLetterRefDoc: [],
      sscListOfAdditionalContactPerson: [],
      sscAdditionalEmailID: "",
      sscCustomerIDEncrypted: "",
      sscCustomerName: "",
      sscCustomerContactPersonIDEncrypted: "",
      sscContactPerson: "",
      sscDesignation: "",
      sscMobileNo: "",
      sscEmailID: "",
      sscContactPersonID: "",
    },
    validateOnBlur: false,
  });

  const {
    values: {
      sscListOfProjectContactPerson,
      sscListOfCustomerContactPerson,
      sscListOfLetterRefDoc,
      sscListOfAdditionalContactPerson,
      sscCustomerIDEncrypted,
      sscCustomerName,
      sscCustomerContactPersonIDEncrypted,
      sscContactPerson,
      sscDesignation,
      sscMobileNo,
      sscEmailID,
      sscContactPersonID,
    },
  } = formikSendScanCopy;

  const openSendScanCopyDialog = async (inwardID, inwardMaterialID = "") => {
    setIsLoading(true);
    await post(POST_GetControlCenterScanCopyEmailDetailList, {
      InwardIDEncrypted: inwardID,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formikSendScanCopy.setValues({
            InwardIDEncrypted: inwardID,
            InwardMaterialIDEncrypted: inwardMaterialID,
            sscListOfProjectContactPerson: response?.ListOfContactPerson?.map(
              (x) => ({
                ...x,
                IsSelected: false,
                ModeType: x?.ModeDetail,
              })
            ),
            sscListOfCustomerContactPerson:
              response?.ListOfCustomerContactPerson?.map((x) => ({
                ...x,
                IsSelected: false,
              })),
            sscListOfLetterRefDoc: response?.ListOfLetterRefDoc?.map((x) => ({
              ...x,
              IsSelected: false,
              LetterRefImageFileName: x?.LetterRefImageFileName,
            })),
            sscListOfAdditionalContactPerson: [],
            sscAdditionalEmailID: "",
            sscCustomerIDEncrypted: "",
            sscCustomerName: "",
            sscCustomerContactPersonIDEncrypted: "",
            sscContactPerson: "",
            sscDesignation: "",
            sscMobileNo: "",
            sscEmailID: "",
            sscContactPersonID: "",
          });
        } else {
          formikSendScanCopy.resetForm();
        }
        setShowSendScanCopyModal(true);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const handleValidSubmitSendScanCopy = async (values) => {
    if (values?.InwardIDEncrypted) {
      let listOfAdditionalEmails = values?.sscAdditionalEmailID?.trim()
        ? cleanCsvString(values?.sscAdditionalEmailID)?.split(",")
        : [];
      if (
        values?.sscListOfProjectContactPerson?.filter(
          (x) => x.IsSelected == true
        )?.length == 0 &&
        values?.sscListOfCustomerContactPerson?.filter(
          (x) => x.IsSelected == true
        )?.length == 0 &&
        values?.sscListOfAdditionalContactPerson?.filter(
          (x) => x.IsSelected == true
        )?.length == 0 &&
        listOfAdditionalEmails?.length == 0
      ) {
        warningMessage(
          "Please select contact person or enter additional email to send!"
        );
      } else {
        if (
          listOfAdditionalEmails?.length > 0 &&
          listOfAdditionalEmails?.filter((x) => validateEmail(x) == null)
            ?.length > 0
        ) {
          formikSendScanCopy.setFieldError(
            "sscAdditionalEmailID",
            "Please check it contains invalid email address"
          );
          formikSendScanCopy.setFieldTouched("sscAdditionalEmailID", true);
        } else {
          setIsLoading(true);

          let emailCsv = "";
          Promise.all(
            values?.sscListOfProjectContactPerson
              ?.filter((x) => x.IsSelected == true)
              ?.map((x) => {
                emailCsv =
                  emailCsv + x.EmailID + ":::" + x.ContactPersonID + ", ";
              }),
            values?.sscListOfCustomerContactPerson
              ?.filter((x) => x.IsSelected == true)
              ?.map((x) => {
                emailCsv =
                  emailCsv + x.EmailID + ":::" + x.ContactPersonID + ", ";
              }),
            values?.sscListOfAdditionalContactPerson
              ?.filter((x) => x.IsSelected == true)
              ?.map((x) => {
                emailCsv =
                  emailCsv + x.EmailID + ":::" + x.ContactPersonID + ", ";
              }),
            listOfAdditionalEmails?.map((email) => {
              emailCsv = emailCsv + email + ":::" + 0 + ", ";
            }),
            (emailCsv = cleanCsvString(emailCsv))
          );

          let payload = {
            BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
            CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
            InwardIDEncrypted: values?.InwardIDEncrypted,
            InwardMaterialIDEncrypted: values?.InwardMaterialIDEncrypted ?? "",
            CreatedByEncrypted: AuthUser?.ReferenceIDEncrypt
              ? AuthUser?.ReferenceIDEncrypt
              : "0",
            EmailIDs: emailCsv,
            ListOfLetterRefDoc: values?.sscListOfLetterRefDoc
              ?.filter((item) => item.IsSelected == true)
              ?.map((x) => ({
                InwardLetterRefImageIDEncrypted:
                  x?.InwardLetterRefImageIDEncrypted,
                AttachmentFilePath: x?.LetterRefImageFilePath,
              })),
          };

          await post(POST_ControlCenterScanCopyEmailSend, payload)
            .then((response) => {
              if (response?.IsSuccess) {
                successMessage(response?.Message);
                getData(currentPage, currentSizePerPage);
                setShowSendScanCopyModal(false);
              } else {
                errorMessage(response?.Message);
              }
              setIsLoading(false);
            })
            .catch((error) => {
              console.log(error);
              setIsLoading(false);
            });
        }
      }
    } else {
      warningMessage("Something went wrong!");
    }
  };

  useEffect(() => {
    if (sscCustomerIDEncrypted) {
      getCustomerContactPersonDDL_SSC(sscCustomerIDEncrypted);
    } else {
      setsscContactPersonOptions([]);
      formikSendScanCopy.setFieldValue(
        "sscCustomerContactPersonIDEncrypted",
        ""
      );
      formikSendScanCopy.setFieldValue("sscContactPerson", "");
      formikSendScanCopy.setFieldValue("sscDesignation", "");
      formikSendScanCopy.setFieldValue("sscMobileNo", "");
      formikSendScanCopy.setFieldValue("sscEmailID", "");
      formikSendScanCopy.setFieldValue("sscContactPersonID", "");
    }
  }, [sscCustomerIDEncrypted]);

  const [
    showWhatsAppMessageSendScanCopyModal,
    setShowWhatsAppMessageSendScanCopyModal,
  ] = useState(false);

  const addAdditionalContactPerson_SSC_WAM = () => {
    if (WAMsscMobileNo) {
      if (WAMsscCustomerIDEncrypted && WAMsscCustomerContactPersonIDEncrypted) {
        if (
          WAMsscListOfAdditionalContactPerson?.filter(
            (x) =>
              x?.CustomerContactPersonIDEncrypted ==
              WAMsscCustomerContactPersonIDEncrypted
          )?.length == 0
        ) {
          formikWhatsAppMessageSendScanCopy.setFieldValue(
            "WAMsscListOfAdditionalContactPerson",
            [
              ...WAMsscListOfAdditionalContactPerson,
              {
                IsSelected: true,
                CustomerName: WAMsscCustomerName,
                CustomerContactPersonIDEncrypted:
                  WAMsscCustomerContactPersonIDEncrypted,
                ContactPerson: WAMsscContactPerson,
                Designation: WAMsscDesignation,
                MobileNo: WAMsscMobileNo,
                EmailID: WAMsscEmailID,
                ContactPersonID: WAMsscContactPersonID,
              },
            ]
          );
          formikWhatsAppMessageSendScanCopy.setFieldValue(
            "WAMsscCustomerContactPersonIDEncrypted",
            ""
          );
          formikWhatsAppMessageSendScanCopy.setFieldValue(
            "WAMsscContactPerson",
            ""
          );
          formikWhatsAppMessageSendScanCopy.setFieldValue(
            "WAMsscDesignation",
            ""
          );
          formikWhatsAppMessageSendScanCopy.setFieldValue("WAMsscMobileNo", "");
          formikWhatsAppMessageSendScanCopy.setFieldValue("WAMsscEmailID", "");
          formikWhatsAppMessageSendScanCopy.setFieldValue(
            "WAMsscContactPersonID",
            ""
          );
        } else {
          //show duplicate error
          warningMessage("Contact Person already exists!");
        }
      } else {
        if (!WAMsscCustomerIDEncrypted) {
          formikWhatsAppMessageSendScanCopy.setFieldError(
            "WAMsscCustomerIDEncrypted",
            "Customer is required field"
          );
          formikWhatsAppMessageSendScanCopy.setFieldTouched(
            "WAMsscCustomerIDEncrypted",
            true
          );
        }
        if (!WAMsscCustomerContactPersonIDEncrypted) {
          formikWhatsAppMessageSendScanCopy.setFieldError(
            "WAMsscCustomerContactPersonIDEncrypted",
            "Contact Person is required field"
          );
          formikWhatsAppMessageSendScanCopy.setFieldTouched(
            "WAMsscCustomerContactPersonIDEncrypted",
            true
          );
        }
      }
    } else {
      warningMessage("Mobile No does not exist...!");
    }
  };

  const validationSchemaWhatsAppMessageSendScanCopy = Yup.object().shape({});

  const formikWhatsAppMessageSendScanCopy = useFormik({
    validationSchemaWhatsAppMessageSendScanCopy,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitWhatsAppMessageSendScanCopy(values, formikHelpers),
    initialValues: {
      InwardIDEncrypted: "",
      InwardMaterialIDEncrypted: "",
      WAMsscListOfProjectContactPerson: [],
      WAMsscListOfCustomerContactPerson: [],
      WAMsscListOfLetterRefDoc: [],
      WAMsscListOfAdditionalContactPerson: [],
      WAMsscAdditionalEmailID: "",
      WAMsscCustomerIDEncrypted: "",
      WAMsscCustomerName: "",
      WAMsscCustomerContactPersonIDEncrypted: "",
      WAMsscContactPerson: "",
      WAMsscDesignation: "",
      WAMsscMobileNo: "",
      WAMsscEmailID: "",
      WAMsscAdditionalMobileNo: "",
      WAMsscContactPersonID: "",
    },
    validateOnBlur: false,
  });

  const {
    values: {
      WAMsscListOfProjectContactPerson,
      WAMsscListOfCustomerContactPerson,
      WAMsscListOfLetterRefDoc,
      WAMsscListOfAdditionalContactPerson,
      WAMsscCustomerIDEncrypted,
      WAMsscCustomerName,
      WAMsscCustomerContactPersonIDEncrypted,
      WAMsscContactPerson,
      WAMsscDesignation,
      WAMsscMobileNo,
      WAMsscEmailID,
      WAMsscAdditionalMobileNo,
      WAMsscContactPersonID,
    },
  } = formikWhatsAppMessageSendScanCopy;

  const handleValidSubmitWhatsAppMessageSendScanCopy = async (values) => {
    if (values?.InwardIDEncrypted) {
      let additionalMobileNumbers = values?.WAMsscAdditionalMobileNo?.trim();

      //const isValidFormat = /^[0-9]+(,[0-9]+)*$/.test(additionalMobileNumbers);

      if (values?.WAMsscAdditionalMobileNo) {
        const isValidFormat = /^(\d{10})(,\d{10})*$/.test(
          additionalMobileNumbers
        );

        if (!isValidFormat) {
          errorMessage(
            "Please enter valid mobile numbers separated by commas."
          );
          return;
        }
      }
      // let listOfAdditionalMobileNo = values?.WAMsscAdditionalMobileNo?.trim()
      //   ? cleanCsvString(values?.WAMsscAdditionalMobileNo)?.split(",")
      //   : [];

      let listOfAdditionalMobileNo = additionalMobileNumbers
        ? cleanCsvString(additionalMobileNumbers)?.split(",")
        : [];

      if (
        values?.WAMsscListOfProjectContactPerson?.filter(
          (x) => x.IsSelected == true
        )?.length == 0 &&
        values?.WAMsscListOfCustomerContactPerson?.filter(
          (x) => x.IsSelected == true
        )?.length == 0 &&
        values?.WAMsscListOfAdditionalContactPerson?.filter(
          (x) => x.IsSelected == true
        )?.length == 0 &&
        listOfAdditionalMobileNo?.length == 0
      ) {
        warningMessage(
          "Please select contact person or enter additional mobile no to send message!"
        );
      } else {
        setIsLoading(true);

        let MobileNoCsv = "";
        Promise.all(
          values?.WAMsscListOfProjectContactPerson?.filter(
            (x) => x.IsSelected == true
          )?.map((x) => {
            MobileNoCsv =
              MobileNoCsv + x?.MobileNo + ":::" + x.ContactPersonID + ", ";
          }),
          values?.WAMsscListOfCustomerContactPerson?.filter(
            (x) => x.IsSelected == true
          )?.map((x) => {
            MobileNoCsv =
              MobileNoCsv + x?.MobileNo + ":::" + x.ContactPersonID + ", ";
          }),
          values?.WAMsscListOfAdditionalContactPerson?.filter(
            (x) => x.IsSelected == true
          )?.map((x) => {
            MobileNoCsv =
              MobileNoCsv + x?.MobileNo + ":::" + x.ContactPersonID + ", ";
          }),
          listOfAdditionalMobileNo?.map((mno) => {
            MobileNoCsv = MobileNoCsv + mno + ":::" + 0 + ", ";
          }),
          (MobileNoCsv = cleanCsvString(MobileNoCsv))
        );

        let payload = {
          BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
          CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
          CreatedByEncrypted: AuthUser?.ReferenceIDEncrypt
            ? AuthUser?.ReferenceIDEncrypt
            : "0",
          InwardIDEncrypted: values?.InwardIDEncrypted,
          InwardMaterialIDEncrypted: values?.InwardMaterialIDEncrypted ?? "",
          MobileNos: MobileNoCsv,
        };

        //console.log("payload", payload);
        //return;

        await post(POST_UploadScanCopiesWhatsAppMessageSend, payload)
          .then((response) => {
            if (response?.IsSuccess) {
              successMessage(response?.Message);
              getData(currentPage, currentSizePerPage);
              setShowWhatsAppMessageSendScanCopyModal(false);
            } else {
              errorMessage(response?.Message);
            }
            setIsLoading(false);
          })
          .catch((error) => {
            console.log(error);
            setIsLoading(false);
          });
      }
    } else {
      warningMessage("Something went wrong!");
    }
  };

  useEffect(() => {
    if (WAMsscCustomerIDEncrypted) {
      getCustomerContactPersonDDL_SSC(WAMsscCustomerIDEncrypted);
    } else {
      setsscContactPersonOptions([]);
      formikWhatsAppMessageSendScanCopy.setFieldValue(
        "WAMsscCustomerContactPersonIDEncrypted",
        ""
      );
      formikWhatsAppMessageSendScanCopy.setFieldValue(
        "WAMsscContactPerson",
        ""
      );
      formikWhatsAppMessageSendScanCopy.setFieldValue("WAMsscDesignation", "");
      formikWhatsAppMessageSendScanCopy.setFieldValue("WAMsscMobileNo", "");
      formikWhatsAppMessageSendScanCopy.setFieldValue("WAMsscEmailID", "");
      formikWhatsAppMessageSendScanCopy.setFieldValue(
        "WAMsscContactPersonID",
        ""
      );
    }
  }, [WAMsscCustomerIDEncrypted]);

  const openScanCopyWhatsAppMessageDialog = async (
    inwardID,
    inwardMaterialID
  ) => {
    setIsLoading(true);
    await post(POST_GetControlCenterScanCopyEmailDetailList, {
      InwardIDEncrypted: inwardID,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formikWhatsAppMessageSendScanCopy.setValues({
            InwardIDEncrypted: inwardID,
            InwardMaterialIDEncrypted: inwardMaterialID,

            WAMsscListOfProjectContactPerson:
              response?.ListOfContactPerson?.filter(
                (item) => item.MobileNo !== ""
              )?.map((x) => ({
                ...x,
                IsSelected: false,
                ModeType: x?.ModeDetail,
              })),

            // WAMsscListOfProjectContactPerson:

            //   response?.ListOfContactPerson?.map((x) => ({
            //     ...x,
            //     IsSelected: false,
            //     ModeType: x?.ModeDetail,
            //   })),

            WAMsscListOfCustomerContactPerson:
              response?.ListOfCustomerContactPerson?.filter(
                (item) => item.MobileNo !== ""
              )?.map((x) => ({
                ...x,
                IsSelected: false,
              })),

            // WAMsscListOfCustomerContactPerson:
            //   response?.ListOfCustomerContactPerson?.map((x) => ({
            //     ...x,
            //     IsSelected: false,
            //   })),
            WAMsscListOfLetterRefDoc: response?.ListOfLetterRefDoc?.map(
              (x) => ({
                ...x,
                IsSelected: false,
                LetterRefImageFileName: x?.LetterRefImageFileName,
              })
            ),
            WAMsscListOfAdditionalContactPerson: [],
            WAMsscAdditionalEmailID: "",
            WAMsscCustomerIDEncrypted: "",
            WAMsscCustomerName: "",
            WAMsscCustomerContactPersonIDEncrypted: "",
            WAMsscContactPerson: "",
            WAMsscDesignation: "",
            WAMsscMobileNo: "",
            WAMsscEmailID: "",
            WAMsscAdditionalMobileNo: "",
            WAMsscContactPersonID: "",
          });
        } else {
          formikWhatsAppMessageSendScanCopy.resetForm();
        }
        setShowWhatsAppMessageSendScanCopyModal(true);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  // const sendScanCopyWhatsAppMessage = async (
  //   inwardID,
  //   inwardMaterialID = ""
  // ) => {
  //   setIsLoading(true);
  //   await post(POST_UploadScanCopiesWhatsAppMessageSend, {
  //     CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
  //     BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
  //     InwardIDEncrypted: inwardID,
  //     InwardMaterialIDEncrypted: inwardMaterialID,
  //   })
  //     .then((response) => {
  //       if (response?.IsSuccess) {
  //         successMessage(response?.Message);
  //         setTimeout(() => {
  //           navigate("/upload-scan-copy-list");
  //           navigate(-1);
  //         }, 1000);
  //       } else {
  //         errorMessage(response?.Message);
  //         setIsLoading(false);
  //       }
  //       setIsLoading(false);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       setIsLoading(false);
  //     });
  // };

  return (
    <>
      <div className="card m-1">
        <div className="card-body p-1">
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <div className="table-responsive active-projects style-1 shorting">
              <div className="tbl-caption p-2">
                <h4 className="heading mb-0">Upload Scan Copy List</h4>
                <div className="d-flex align-items-center">
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={(e) => {
                      getResetData();
                    }}
                  >
                    <i className="fa fa-window-restore" aria-hidden="true"></i>
                    {"  "} Reset
                  </button>

                  <button
                    type="button"
                    // className="btn btn-primary btn-sm me-2"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={(e) => {
                      getData();
                      // setShowFilter(false);
                    }}
                  >
                    <i className="fa-solid fa-refresh me-2"></i> Reload
                  </button>
                  <button
                    type="button"
                    // className="btn btn-primary btn-sm me-2"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={() => setShowFilter(!showFilter)}
                  >
                    <i className="fa-solid fa-filter me-2"></i>Filter
                  </button>
                  {AuthUser?.UserType !== 1 ||
                  formsList?.filter((x) => x?.FormID == 37 && x?.IsAdd)
                    ?.length > 0 ? (
                    <Link
                      to="/add-upload-scan-copy"
                      // className="btn btn-primary btn-sm"
                      className="btn btn-outline-primary btn-sm"
                    >
                      <i className="fa-solid fa-plus"></i> Add New
                    </Link>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <hr className="mt-0 mb-1"></hr>
              <div className="p-2 pt-0 pb-0">
                {showFilter ? (
                  <div>
                    <FormikProvider value={formikFilter}>
                      <Form onSubmit={formikFilter.handleSubmit}>
                        <Row className="me-0">
                          <Col lg={3}>
                            <Field
                              label="TC No"
                              name="TCNo"
                              placeholder={"Search here..."}
                              component={CustomInput}
                            />
                          </Col>
                          <Col lg={3}>
                            <Field
                              label="Inward No"
                              name="InwardNo"
                              placeholder={"Search here..."}
                              component={CustomInput}
                            />
                          </Col>

                          <Col lg={2}>
                            <Field
                              label="From Date"
                              name="FromDate"
                              placeholder={"Select From Date"}
                              component={CustomFlatpickr}
                              options={{
                                altInput: true,
                                altFormat: "j-M-Y",
                                dateFormat: "d-m-Y",
                              }}
                            />
                          </Col>
                          <Col lg={2}>
                            <Field
                              label="To Date"
                              name="ToDate"
                              placeholder={"Select To Date"}
                              component={CustomFlatpickr}
                              options={{
                                altInput: true,
                                altFormat: "j-M-Y",
                                dateFormat: "d-m-Y",
                                minDate: FromDate,
                              }}
                            />
                          </Col>
                        </Row>
                        <Row className="me-0">
                          <Col lg={3}>
                            <Field
                              label="Sample Detail"
                              name="SampleDetail"
                              placeholder={"Search here..."}
                              component={CustomInput}
                            />
                          </Col>
                          <Col lg={3}>
                            <Field
                              label="Customer"
                              name="CustomerID"
                              placeholder={"Select Customer"}
                              options={customerOptionList}
                              component={CustomSelect}
                              menuPosition="fixed"
                            />
                          </Col>

                          <Col lg={2}>
                            <Field
                              label="Scan Barcode"
                              name="ScanBarcode"
                              placeholder={"Search here..."}
                              component={CustomInput}
                            />
                          </Col>
                          {AuthUser?.Permissions?.Email == 1 ? (
                            <Col lg={2}>
                              <Field
                                label="Mail Send"
                                name="MailSent"
                                placeholder={"Select Mail Send"}
                                options={mailSentOptions}
                                component={CustomSelect}
                                isClearable={false}
                              />
                            </Col>
                          ) : (
                            ""
                          )}

                          <Col lg={2}>
                            <label className="mb-1">&nbsp;</label>
                            <div className="d-flex">
                              <div className="d-lg-block">
                                <Link
                                  // className="btn btn-primary btn-sm mb-1"
                                  className="btn btn-primary btn-sm mb-1"
                                  onClick={(e) => {
                                    getData();
                                  }}
                                >
                                  <i
                                    className="fa fa-search"
                                    aria-hidden="true"
                                  ></i>{" "}
                                  Search
                                </Link>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </FormikProvider>
                  </div>
                ) : (
                  ""
                )}
                {AuthUser?.IsUploadScanCopyEmailSetup == false &&
                  AuthUser?.Permissions?.Email == 1 && (
                    <div className="text-danger">
                      Note: In Application setup - Upload Scan Copy Mail Setting
                      is pending. So user wan't be able to send emails.
                    </div>
                  )}
                <div
                  id="UploadScanCopy-tbl_wrapper"
                  className="dataTables_wrapper table-responsive no-footer"
                >
                  <table
                    id="UploadScanCopy-tbl"
                    className="table dataTable no-footer mb-0"
                  >
                    <thead>
                      <tr>
                        <th width="3%"></th>
                        <th
                          style={{
                            width: "12%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("TCNo");
                          }}
                        >
                          TC No{" "}
                          <span className="ml-1">
                            {sortBy == "TCNo" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "12%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("InwardNo");
                          }}
                        >
                          Inward No{" "}
                          <span className="ml-1">
                            {sortBy == "InwardNo" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "15%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("CustomerName");
                          }}
                        >
                          Customer
                          <span className="ml-1">
                            {sortBy == "CustomerName" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "15%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("TestName");
                          }}
                        >
                          Test
                          <span className="ml-1">
                            {sortBy == "TestName" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "15%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("UploadedBy");
                          }}
                        >
                          Uploaded By/Date
                          <span className="ml-1">
                            {sortBy == "UploadedBy" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "15%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("SampleDetail");
                          }}
                        >
                          Sample Detail{" "}
                          <span className="ml-1">
                            {sortBy == "SampleDetail" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "10%",
                            cursor: "pointer",
                            textAlign: "left",
                          }}
                          onClick={() => {
                            handleClickSorting("WhatsAppMessageSend");
                          }}
                        >
                          WhatsApp Send{" "}
                          <span className="ml-1">
                            {sortBy == "WhatsAppMessageSend" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        {AuthUser?.Permissions?.Email == 1 ? (
                          <th
                            style={{
                              width: "10%",
                              cursor: "pointer",
                              textAlign: "left",
                            }}
                            onClick={() => {
                              handleClickSorting("MailSendBy");
                            }}
                          >
                            Mail Send{" "}
                            <span className="ml-1">
                              {sortBy == "MailSendBy" ? (
                                orderBy == "desc" ? (
                                  <i
                                    className="fa fa-arrow-down ms-2 fs-14"
                                    style={{ opacity: "0.7" }}
                                  />
                                ) : (
                                  <i
                                    className="fa fa-arrow-up ms-2 fs-14"
                                    style={{ opacity: "0.7" }}
                                  />
                                )
                              ) : (
                                <i
                                  className="fa fa-sort ms-2 fs-14"
                                  style={{ opacity: "0.3" }}
                                />
                              )}
                            </span>
                          </th>
                        ) : (
                          ""
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {uploadScanCopyList?.length > 0 ? (
                        uploadScanCopyList?.map((item, indx) => (
                          <>
                            <tr key={indx}>
                              <td style={{ verticalAlign: "top" }}>
                                {AuthUser?.UserType !== 1 ||
                                formsList?.filter(
                                  (x) => x?.FormID == 37 && x?.IsEdit
                                )?.length > 0 ? (
                                  <Link
                                    to={
                                      item?.IsHold == true
                                        ? "#"
                                        : `/edit-upload-scan-copy/${window.btoa(
                                            item.InwardIDEncrypted
                                          )}`
                                    }
                                    className="icon-box icon-box-md me-1"
                                    title="Edit"
                                    disabled={item?.IsHold}
                                  >
                                    {SVGICON.EditPrimary}
                                  </Link>
                                ) : (
                                  ""
                                )}
                                {AuthUser?.UserType !== 1 ||
                                formsList?.filter(
                                  (x) => x?.FormID == 37 && x?.IsDelete
                                )?.length > 0 ? (
                                  <Link
                                    to="#"
                                    // className="icon-box icon-box-md bg-danger-light me-1"
                                    className="icon-box icon-box-md me-1"
                                    title="Delete"
                                    onClick={() => {
                                      if (item?.IsHold == false) {
                                        delete_Record(
                                          POST_UploadScanCopiesDelete,
                                          {
                                            UploadScanCopyIDEncrypted:
                                              item?.UploadScanCopyIDEncrypted,
                                            ModifiedByEncrypted:
                                              AuthUser?.ReferenceIDEncrypt
                                                ? AuthUser?.ReferenceIDEncrypt
                                                : "0",
                                          },
                                          setIsLoading,
                                          fnCallback,
                                          item.TCNo
                                        );
                                      }
                                    }}
                                    disabled={item?.IsHold}
                                  >
                                    {SVGICON.DeleteDanger}
                                  </Link>
                                ) : (
                                  ""
                                )}
                                {AuthUser?.UserType !== 1 ||
                                formsList?.filter(
                                  (x) =>
                                    x?.FormID == 37 && (x?.IsAdd || x?.Edit)
                                )?.length > 0 ? (
                                  <>
                                    <Link
                                      to="#"
                                      className="icon-box icon-box-md me-1"
                                      title="Upload Additional Doc"
                                      onClick={(e) => {
                                        if (item?.IsHold == false) {
                                          addUploadAdditionalDoc(
                                            item.UploadScanCopyIDEncrypted
                                          );
                                          formikUploadAdditionalDoc.setFieldValue(
                                            "InwardMaterialIDEncrypt",
                                            ""
                                          );
                                          formikUploadAdditionalDoc.setFieldValue(
                                            "InwardMaterialIDEncrypt",
                                            item.InwardMaterialIDEncrypted
                                          );
                                          formikUploadAdditionalDoc.setFieldValue(
                                            "UploadScanCopyIDEncrypted",
                                            item.UploadScanCopyIDEncrypted
                                          );
                                        }
                                      }}
                                      disabled={item?.IsHold}
                                    >
                                      {SVGICON.Upload}
                                    </Link>
                                    {AuthUser?.Permissions?.Email == 1 ? (
                                      <Link
                                        className="icon-box icon-box-md me-1"
                                        title="Send Mail"
                                        onClick={() => {
                                          if (item?.IsHold == false) {
                                            openSendScanCopyDialog(
                                              item?.InwardIDEncrypted,
                                              item?.InwardMaterialIDEncrypted
                                            );
                                          }
                                        }}
                                        // onClick={() => {
                                        //   infoMessage("Coming Soon...");
                                        // }}
                                        disabled={item?.IsHold}
                                      >
                                        {SVGICON.Message}
                                      </Link>
                                    ) : (
                                      ""
                                    )}
                                  </>
                                ) : (
                                  ""
                                )}

                                {AuthUser?.UserType == 1 &&
                                AuthUser?.Permissions?.Whatsup == 1 &&
                                formsList?.filter(
                                  (x) =>
                                    x?.FormID == 81 && (x?.IsAdd || x?.IsEdit)
                                )?.length > 0 ? (
                                  <>
                                    <Link
                                      className="icon-box icon-box-md me-1"
                                      title="Send WhatsApp Message"
                                      onClick={() => {
                                        if (item?.IsHold == false) {
                                          openScanCopyWhatsAppMessageDialog(
                                            item?.InwardIDEncrypted,
                                            item?.InwardMaterialIDEncrypted
                                          );
                                        }
                                      }}
                                      disabled={item?.IsHold}
                                    >
                                      {SVGICON.WhatsApp}
                                    </Link>
                                  </>
                                ) : (
                                  ""
                                )}

                                {AuthUser?.UserType !== 1 ||
                                formsList?.filter(
                                  (x) =>
                                    x?.FormID == 34 &&
                                    (x?.IsRead ||
                                      x?.IsAdd ||
                                      x?.IsEdit ||
                                      x?.IsActive ||
                                      x?.IsDelete ||
                                      x?.IsExport)
                                )?.length > 0 ? (
                                  <Link
                                    className="icon-box icon-box-md"
                                    title="Go to Reporting"
                                    to={
                                      item?.IsHold == true
                                        ? "#"
                                        : "/report-printing-list"
                                    }
                                    disabled={item?.IsHold}
                                  >
                                    <i className="fa fa-history"></i>
                                  </Link>
                                ) : (
                                  ""
                                )}
                              </td>
                              <td style={{ verticalAlign: "top" }}>
                                {item.TCNo}{" "}
                                {item?.IsHold == true && (
                                  <>
                                    <b>[Hold]</b>
                                    <OverlayTrigger
                                      trigger={["hover", "focus"]}
                                      key={indx}
                                      responsive={true}
                                      overlay={
                                        <Tooltip className="toltip-popover">
                                          <strong className="p-1">
                                            <label>Hold:</label>{" "}
                                            {item?.HoldReason}
                                          </strong>
                                        </Tooltip>
                                      }
                                    >
                                      <span>
                                        <i
                                          className="fa fa-info-circle ms-2"
                                          style={{
                                            cursor: "pointer",
                                            color: "#9698ab",
                                          }}
                                        ></i>
                                      </span>
                                    </OverlayTrigger>
                                  </>
                                )}
                              </td>
                              <td style={{ verticalAlign: "top" }}>
                                {item.InwardNo}
                              </td>
                              <td style={{ verticalAlign: "top" }}>
                                {item.CustomerName}
                              </td>

                              <td
                                style={{
                                  verticalAlign: "top",
                                  textAlign: "left",
                                  cursor: "pointer",
                                }}
                                className="popupOverlay"
                              >
                                <OverlayTrigger
                                  trigger={["hover", "focus"]}
                                  key={indx}
                                  responsive={true}
                                  overlay={
                                    <Tooltip className="toltip-popover">
                                      <strong className="p-1">
                                        {item.TestName}
                                      </strong>
                                    </Tooltip>
                                  }
                                >
                                  <span>{item.TestName}</span>
                                </OverlayTrigger>
                              </td>
                              <td style={{ verticalAlign: "top" }}>
                                {item.ModifiedBy
                                  ? item.ModifiedBy
                                  : item.CreatedBy}
                                <br></br>
                                {item.ModifiedOnDate
                                  ? item.ModifiedOnDate
                                  : item.CreatedOnDate}
                              </td>

                              <td
                                style={{
                                  verticalAlign: "top",
                                  textAlign: "left",
                                  cursor: "pointer",
                                }}
                                className="popupOverlay"
                              >
                                <OverlayTrigger
                                  trigger={["hover", "focus"]}
                                  key={indx}
                                  responsive={true}
                                  overlay={
                                    <Tooltip className="toltip-popover">
                                      <strong className="p-1">
                                        {item.SampleDetail}
                                      </strong>
                                    </Tooltip>
                                  }
                                >
                                  <span>{item.SampleDetail}</span>
                                </OverlayTrigger>
                              </td>
                              <td
                                style={{
                                  verticalAlign: "top",
                                  textAlign: "left",
                                }}
                              >
                                {item.WhatsAppMessageSend == true ? (
                                  <>
                                    Yes <br></br>
                                    {item.WhatsAppMessageSendBy}
                                    <br></br>
                                    {item.WhatsAppMessageSendDate}
                                  </>
                                ) : (
                                  "No"
                                )}
                              </td>
                              {AuthUser?.Permissions?.Email == 1 ? (
                                <td style={{ textAlign: "left" }}>
                                  {item.IsMailSend == true ? "Yes" : "No"}
                                  <br />
                                  {item.MailSendBy ? item.MailSendBy : ""}
                                  <br />
                                  {item.MailSendDate ? item.MailSendDate : ""}
                                </td>
                              ) : (
                                ""
                              )}
                            </tr>
                          </>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={10} style={{ textAlign: "left" }}>
                            <div>{"No Record Found..."}</div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>

                  <hr className="mt-0 mb-1"></hr>
                  <div className="d-sm-flex text-center justify-content-between align-items-center ">
                    <CustomSizePerPage
                      getData={getData}
                      currentSizePerPage={currentSizePerPage}
                    />
                    <div className="dataTables_info">
                      Showing{" "}
                      {recordCount > 0
                        ? (currentPage - 1) * currentSizePerPage + 1
                        : 0}{" "}
                      to{" "}
                      {recordCount > currentPage * currentSizePerPage
                        ? currentPage * currentSizePerPage
                        : recordCount}{" "}
                      of {recordCount} entries
                    </div>
                    <CustomPaginationButtons
                      totalPages={recordCount / currentSizePerPage}
                      currentPage={currentPage}
                      currentSizePerPage={currentSizePerPage}
                      getData={getData}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Spin>
          <Modal
            className="fade"
            show={showUploadAdditionalDocModel}
            onHide={setShowUploadAdditionalDocModel}
          >
            <Spin
              size="large"
              spinning={isLoading}
              tip={"Loading..."}
              style={{ position: "fixed" }}
            >
              <FormikProvider value={formikUploadAdditionalDoc}>
                <Form onSubmit={formikUploadAdditionalDoc.handleSubmit}>
                  <Modal.Header>
                    <Modal.Title>Upload Additional Doc</Modal.Title>
                    <Button
                      type="button"
                      variant=""
                      className="btn-close"
                      onClick={() => setShowUploadAdditionalDocModel(false)}
                    ></Button>
                  </Modal.Header>
                  <Modal.Body>
                    <Row>
                      <Col lg={12}>
                        <div style={{ float: "right", marginRight: "2rem" }}>
                          + Add
                          <div
                            className="open-file mt-2"
                            style={{
                              marginLeft: "2rem",
                            }}
                          >
                            <input
                              type="file"
                              id="uploadAdditionalDocfile"
                              // accept=".doc,.docx,application/pdf"
                              onChange={uploadAdditionalDocChange}
                            />
                            <label
                              htmlFor="uploadAdditionalDocfile"
                              name=""
                            ></label>
                          </div>
                        </div>
                      </Col>

                      <Col lg={12}>
                        <div className="table-responsive active-projects style-1 shorting mb-2">
                          <div
                            id="UploadAdditionalDoc-tbl_wrapper"
                            className="dataTables_wrapper no-footer"
                          >
                            <table
                              id="UploadAdditionalDoc-tbl"
                              className="table dataTable no-footer mb-0"
                            >
                              <thead>
                                <tr>
                                  <th width="4%"></th>
                                  <th width="96%" style={{ textAlign: "left" }}>
                                    File
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {ListOfUploadAdditionalDocFile?.filter(
                                  (x) => x.IsDeleted == false
                                )?.length > 0 ? (
                                  ListOfUploadAdditionalDocFile?.map(
                                    (item, indx) => (
                                      <tr
                                        key={indx}
                                        style={{
                                          display:
                                            item.IsDeleted == true
                                              ? "none"
                                              : "",
                                        }}
                                      >
                                        <td>
                                          <Link
                                            to="#"
                                            // className="icon-box icon-box-md bg-primary-light me-1"
                                            className="icon-box icon-box-md me-1"
                                            title="View"
                                            onClick={() => {
                                              window.open(
                                                item.UploadAdditionalDocFilePath
                                                  ? item.UploadAdditionalDocFilePath
                                                  : item.viewUploadAdditionalDocFile
                                              );
                                            }}
                                          >
                                            <i className="fa fa-eye" />
                                          </Link>
                                          <Link
                                            to="#"
                                            // className="icon-box icon-box-md bg-danger-light"
                                            className="icon-box icon-box-md me-1"
                                            title="Delete"
                                            onClick={() => {
                                              //deleteUploadAdditionalDoc(indx);
                                              delete_RecordWithoutApi(
                                                deleteUploadAdditionalDoc,
                                                indx
                                              );
                                            }}
                                          >
                                            {SVGICON.DeleteDanger}
                                          </Link>
                                        </td>
                                        <td style={{ textAlign: "left" }}>
                                          {item.UploadAdditionalDocFileName}
                                        </td>
                                      </tr>
                                    )
                                  )
                                ) : (
                                  <tr>
                                    <td
                                      colSpan={2}
                                      style={{ textAlign: "left" }}
                                    >
                                      <div>{"No Record Found..."}</div>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      // variant="primary"
                      variant="primary btn-sm"
                      type="submit"
                    >
                      <i className="fa fa-cloud-upload"></i> Upload
                    </Button>
                    <Button
                      // variant="secondary light"
                      variant="danger btn-sm"
                      onClick={() => setShowUploadAdditionalDocModel(false)}
                    >
                      <i className="fa fa-cancel"></i> Cancel
                    </Button>
                  </Modal.Footer>
                </Form>
              </FormikProvider>
            </Spin>
          </Modal>

          <Modal
            className="fade"
            show={showSendScanCopyModal}
            onHide={setShowSendScanCopyModal}
            size="xl"
            backdrop="static"
          >
            <Spin
              size="large"
              spinning={isLoading}
              tip={"Loading..."}
              style={{ position: "fixed" }}
            >
              <FormikProvider value={formikSendScanCopy}>
                <Form onSubmit={formikSendScanCopy.handleSubmit}>
                  <Modal.Header>
                    <Modal.Title>Scan Copy Email</Modal.Title>
                    <Button
                      type="button"
                      variant=""
                      className="btn-close"
                      onClick={() => setShowSendScanCopyModal(false)}
                    ></Button>
                  </Modal.Header>
                  <Modal.Body>
                    <div className="d-flex justify-content-between mb-2">
                      <h5 className="mb-0">Project Contact Person</h5>
                    </div>
                    <div className="table-responsive active-projects style-1 shorting">
                      <div
                        id="ProjectContactPersons-tbl_wrapper"
                        className="dataTables_wrapper no-footer"
                      >
                        <table
                          id="ProjectContactPersons-tbl"
                          className="table dataTable no-footer"
                        >
                          <thead>
                            <tr>
                              <th style={{ width: "3%" }}></th>
                              <th style={{ width: "3%" }}></th>
                              <th style={{ width: "14%" }}>Mode Type</th>
                              <th style={{ width: "15%" }}>Customer Name</th>
                              <th style={{ width: "20%" }}>Contact Person</th>
                              <th style={{ width: "15%" }}>Designation</th>
                              <th style={{ width: "15%" }}>Mobile No</th>
                              <th style={{ width: "15%", textAlign: "left" }}>
                                Email
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {sscListOfProjectContactPerson?.length > 0 ? (
                              sscListOfProjectContactPerson?.map(
                                (item, idx) => (
                                  <tr>
                                    <td>{idx + 1}</td>
                                    <td>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="checkIsSelectedPCP"
                                        checked={item?.IsSelected}
                                        onChange={() => {
                                          formikSendScanCopy.setFieldValue(
                                            `sscListOfProjectContactPerson[${idx}].IsSelected`,
                                            !item?.IsSelected
                                          );
                                        }}
                                        style={{ cursor: "pointer" }}
                                      ></input>
                                    </td>
                                    <td>{item?.ModeType}</td>
                                    <td>{item?.CustomerName}</td>
                                    <td>{item?.ContactPerson}</td>
                                    <td>{item?.Designation}</td>
                                    <td>{item?.MobileNo}</td>
                                    <td style={{ textAlign: "left" }}>
                                      {item?.EmailID}
                                    </td>
                                  </tr>
                                )
                              )
                            ) : (
                              <tr>
                                <td
                                  colSpan={8}
                                  style={{
                                    textAlign: "left",
                                  }}
                                >
                                  <div>{"No Record Found..."}</div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <Row>
                      <Col lg={12}>
                        <hr className="mt-1 mb-1"></hr>
                        <div className="d-flex justify-content-between mb-2">
                          <h5 className="mb-0">Customer Contact Person</h5>
                        </div>
                        <div className="table-responsive active-projects style-1 shorting">
                          <div
                            id="CustomerContactPersons-tbl_wrapper"
                            className="dataTables_wrapper no-footer"
                          >
                            <table
                              id="CustomerContactPersons-tbl"
                              className="table dataTable no-footer"
                            >
                              <thead>
                                <tr>
                                  <th style={{ width: "3%" }}></th>
                                  <th style={{ width: "3%" }}></th>
                                  <th style={{ width: "20%" }}>
                                    Customer Name
                                  </th>
                                  <th style={{ width: "24%" }}>
                                    Contact Person
                                  </th>
                                  <th style={{ width: "20%" }}>Designation</th>
                                  <th style={{ width: "15%" }}>Mobile No</th>
                                  <th
                                    style={{ width: "15%", textAlign: "left" }}
                                  >
                                    Email
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {sscListOfCustomerContactPerson?.length > 0 ? (
                                  sscListOfCustomerContactPerson?.map(
                                    (item, idx) => (
                                      <tr>
                                        <td>{idx + 1}</td>
                                        <td>
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id="checkIsSelectedPCP"
                                            checked={item?.IsSelected}
                                            onChange={() => {
                                              formikSendScanCopy.setFieldValue(
                                                `sscListOfCustomerContactPerson[${idx}].IsSelected`,
                                                !item?.IsSelected
                                              );
                                            }}
                                            style={{ cursor: "pointer" }}
                                          ></input>
                                        </td>
                                        <td>{item?.CustomerName}</td>
                                        <td>{item?.ContactPerson}</td>
                                        <td>{item?.Designation}</td>
                                        <td>{item?.MobileNo}</td>
                                        <td style={{ textAlign: "left" }}>
                                          {item?.EmailID}
                                        </td>
                                      </tr>
                                    )
                                  )
                                ) : (
                                  <tr>
                                    <td
                                      colSpan={7}
                                      style={{
                                        textAlign: "left",
                                      }}
                                    >
                                      <div>{"No Record Found..."}</div>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <hr className="mt-1 mb-1"></hr>
                    <Row>
                      <Col lg={3}>
                        <Field
                          label="Customer"
                          name="sscCustomerIDEncrypted"
                          placeholder={"Select Customer"}
                          loadOptionsFn={loadOptionsCustomer_SSC}
                          component={CustomSelectAsync}
                          title={sscCustomerName}
                          labelFieldName="sscCustomerName"
                          menuPosition="fixed"
                        />
                      </Col>
                      <Col lg={3}>
                        <Field
                          label="Contact Person"
                          name="sscCustomerContactPersonIDEncrypted"
                          placeholder={"Select Contact Person"}
                          options={sscContactPersonOptions}
                          component={CustomSelect}
                          menuPosition="fixed"
                          onChange={(e) => {
                            formikSendScanCopy.setFieldValue(
                              "sscCustomerContactPersonIDEncrypted",
                              e?.value ?? ""
                            );
                            formikSendScanCopy.setFieldValue(
                              "sscContactPerson",
                              e?.label ?? ""
                            );
                            formikSendScanCopy.setFieldValue(
                              "sscDesignation",
                              e?.Designation ?? ""
                            );
                            formikSendScanCopy.setFieldValue(
                              "sscMobileNo",
                              e?.MobileNo ?? ""
                            );
                            formikSendScanCopy.setFieldValue(
                              "sscEmailID",
                              e?.EmailID ?? ""
                            );
                            formikSendScanCopy.setFieldValue(
                              "sscContactPersonID",
                              e?.ContactPersonID ?? ""
                            );
                          }}
                        />
                      </Col>
                      <Col lg={3}>
                        <div className="mb-2">
                          <label className="mb-1">&nbsp;</label>
                          <div>
                            <button
                              type="button"
                              // className="btn btn-primary btn-sm "
                              className="btn btn-outline-primary btn-sm"
                              onClick={(e) => {
                                addAdditionalContactPerson_SSC();
                              }}
                            >
                              + Add
                            </button>
                          </div>
                        </div>
                      </Col>
                      <Col lg={12}>
                        <div className="table-responsive active-projects style-1 shorting">
                          <div
                            id="AdditionalContactPerson-tbl_wrapper"
                            className="dataTables_wrapper no-footer"
                          >
                            <table
                              id="AdditionalContactPerson-tbl"
                              className="table dataTable no-footer"
                            >
                              <thead>
                                <tr>
                                  <th style={{ width: "3%" }}></th>
                                  <th style={{ width: "3%" }}></th>
                                  <th style={{ width: "24%" }}>
                                    Customer Name
                                  </th>
                                  <th style={{ width: "20%" }}>
                                    Contact Person
                                  </th>
                                  <th style={{ width: "20%" }}>Designation</th>
                                  <th style={{ width: "15%" }}>Mobile No</th>
                                  <th
                                    style={{ width: "15%", textAlign: "left" }}
                                  >
                                    Email
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {sscListOfAdditionalContactPerson?.length >
                                0 ? (
                                  sscListOfAdditionalContactPerson?.map(
                                    (item, idx) => (
                                      <tr>
                                        <td>{idx + 1}</td>
                                        <td>
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id="checkIsSelectedACP"
                                            checked={item?.IsSelected}
                                            onChange={() => {
                                              formikSendScanCopy.setFieldValue(
                                                `sscListOfAdditionalContactPerson[${idx}].IsSelected`,
                                                !item?.IsSelected
                                              );
                                            }}
                                            style={{ cursor: "pointer" }}
                                          ></input>
                                        </td>
                                        <td>{item?.CustomerName}</td>
                                        <td>{item?.ContactPerson}</td>
                                        <td>{item?.Designation}</td>
                                        <td>{item?.MobileNo}</td>
                                        <td style={{ textAlign: "left" }}>
                                          {item?.EmailID}
                                        </td>
                                      </tr>
                                    )
                                  )
                                ) : (
                                  <tr>
                                    <td
                                      colSpan={7}
                                      style={{
                                        textAlign: "left",
                                      }}
                                    >
                                      <div>{"No Record Found..."}</div>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={6}>
                        <Field
                          label="Additional Email"
                          name="sscAdditionalEmailID"
                          placeholder={"Enter Additional Email"}
                          component={CustomInput}
                        />
                      </Col>
                      <Col lg={6}>
                        <div className="table-responsive active-projects style-1 shorting">
                          <div
                            id="LetterRefDoc-tbl_wrapper"
                            className="dataTables_wrapper no-footer"
                          >
                            <table
                              id="LetterRefDoc-tbl"
                              className="table dataTable no-footer"
                            >
                              <thead>
                                <tr>
                                  <th style={{ width: "5%" }}></th>
                                  <th style={{ width: "5%" }}></th>
                                  <th
                                    style={{ width: "90%", textAlign: "left" }}
                                  >
                                    Letter Ref Doc
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {sscListOfLetterRefDoc?.length > 0 ? (
                                  sscListOfLetterRefDoc?.map((item, idx) => (
                                    <tr>
                                      <td>{idx + 1}</td>
                                      <td>
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          id="checkIsSelectedPCP"
                                          checked={item?.IsSelected}
                                          onChange={() => {
                                            formikSendScanCopy.setFieldValue(
                                              `sscListOfLetterRefDoc[${idx}].IsSelected`,
                                              !item?.IsSelected
                                            );
                                          }}
                                          style={{ cursor: "pointer" }}
                                        ></input>
                                      </td>
                                      <td style={{ textAlign: "left" }}>
                                        <Link
                                          to="#"
                                          // className="icon-box icon-box-md bg-primary-light me-1"
                                          className="icon-box icon-box-md me-1"
                                          title="View"
                                          onClick={() => {
                                            window.open(
                                              item?.LetterRefImageFilePath
                                            );
                                          }}
                                        >
                                          <i className="fa fa-eye" />
                                        </Link>
                                        &nbsp;{item.LetterRefImageFileName}
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td
                                      colSpan={3}
                                      style={{
                                        textAlign: "left",
                                      }}
                                    >
                                      <div>{"No Record Found..."}</div>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="primary btn-sm" type="submit">
                      <i className="fa fa-envelope"></i> Send Mail
                    </Button>
                    <Button
                      variant="danger btn-sm"
                      onClick={() => setShowSendScanCopyModal(false)}
                    >
                      <i className="fa fa-cancel"></i> Cancel
                    </Button>
                  </Modal.Footer>
                </Form>
              </FormikProvider>
            </Spin>
          </Modal>
          <Modal
            className="fade"
            show={showWhatsAppMessageSendScanCopyModal}
            onHide={setShowWhatsAppMessageSendScanCopyModal}
            size="xl"
            backdrop="static"
          >
            <Spin
              size="large"
              spinning={isLoading}
              tip={"Loading..."}
              style={{ position: "fixed" }}
            >
              <FormikProvider value={formikWhatsAppMessageSendScanCopy}>
                <Form onSubmit={formikWhatsAppMessageSendScanCopy.handleSubmit}>
                  <Modal.Header>
                    <Modal.Title>Send Scan Copy WhatsApp Message</Modal.Title>
                    <Button
                      type="button"
                      variant=""
                      className="btn-close"
                      onClick={() =>
                        setShowWhatsAppMessageSendScanCopyModal(false)
                      }
                    ></Button>
                  </Modal.Header>
                  <Modal.Body>
                    <div className="d-flex justify-content-between mb-2">
                      <h5 className="mb-0">Project Contact Person</h5>
                    </div>
                    <div className="table-responsive active-projects style-1 shorting">
                      <div
                        id="ProjectContactPersons-tbl_wrapper"
                        className="dataTables_wrapper no-footer"
                      >
                        <table
                          id="ProjectContactPersons-tbl"
                          className="table dataTable no-footer"
                        >
                          <thead>
                            <tr>
                              <th style={{ width: "3%" }}></th>
                              <th style={{ width: "3%" }}></th>
                              <th style={{ width: "14%" }}>Mode Type</th>
                              <th style={{ width: "15%" }}>Customer Name</th>
                              <th style={{ width: "20%" }}>Contact Person</th>
                              <th style={{ width: "15%" }}>Designation</th>
                              <th style={{ width: "15%" }}>Mobile No</th>
                              <th style={{ width: "15%", textAlign: "left" }}>
                                Email
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {WAMsscListOfProjectContactPerson?.length > 0 ? (
                              WAMsscListOfProjectContactPerson?.map(
                                (item, idx) => (
                                  <tr>
                                    <td>{idx + 1}</td>
                                    <td>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="checkIsSelectedPCP"
                                        checked={item?.IsSelected}
                                        onChange={() => {
                                          formikWhatsAppMessageSendScanCopy.setFieldValue(
                                            `WAMsscListOfProjectContactPerson[${idx}].IsSelected`,
                                            !item?.IsSelected
                                          );
                                        }}
                                        style={{ cursor: "pointer" }}
                                      ></input>
                                    </td>
                                    <td>{item?.ModeType}</td>
                                    <td>{item?.CustomerName}</td>
                                    <td>{item?.ContactPerson}</td>
                                    <td>{item?.Designation}</td>
                                    <td>{item?.MobileNo}</td>
                                    <td style={{ textAlign: "left" }}>
                                      {item?.EmailID}
                                    </td>
                                  </tr>
                                )
                              )
                            ) : (
                              <tr>
                                <td
                                  colSpan={8}
                                  style={{
                                    textAlign: "left",
                                  }}
                                >
                                  <div>{"No Record Found..."}</div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <Row>
                      <Col lg={12}>
                        <hr className="mt-1 mb-1"></hr>
                        <div className="d-flex justify-content-between mb-2">
                          <h5 className="mb-0">Customer Contact Person</h5>
                        </div>
                        <div className="table-responsive active-projects style-1 shorting">
                          <div
                            id="CustomerContactPersons-tbl_wrapper"
                            className="dataTables_wrapper no-footer"
                          >
                            <table
                              id="CustomerContactPersons-tbl"
                              className="table dataTable no-footer"
                            >
                              <thead>
                                <tr>
                                  <th style={{ width: "3%" }}></th>
                                  <th style={{ width: "3%" }}></th>
                                  <th style={{ width: "20%" }}>
                                    Customer Name
                                  </th>
                                  <th style={{ width: "24%" }}>
                                    Contact Person
                                  </th>
                                  <th style={{ width: "20%" }}>Designation</th>
                                  <th style={{ width: "15%" }}>Mobile No</th>
                                  <th
                                    style={{ width: "15%", textAlign: "left" }}
                                  >
                                    Email
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {WAMsscListOfCustomerContactPerson?.length >
                                0 ? (
                                  WAMsscListOfCustomerContactPerson?.map(
                                    (item, idx) => (
                                      <tr>
                                        <td>{idx + 1}</td>
                                        <td>
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id="checkIsSelectedPCP"
                                            checked={item?.IsSelected}
                                            onChange={() => {
                                              formikWhatsAppMessageSendScanCopy.setFieldValue(
                                                `WAMsscListOfCustomerContactPerson[${idx}].IsSelected`,
                                                !item?.IsSelected
                                              );
                                            }}
                                            style={{ cursor: "pointer" }}
                                          ></input>
                                        </td>
                                        <td>{item?.CustomerName}</td>
                                        <td>{item?.ContactPerson}</td>
                                        <td>{item?.Designation}</td>
                                        <td>{item?.MobileNo}</td>
                                        <td style={{ textAlign: "left" }}>
                                          {item?.EmailID}
                                        </td>
                                      </tr>
                                    )
                                  )
                                ) : (
                                  <tr>
                                    <td
                                      colSpan={10}
                                      style={{
                                        textAlign: "left",
                                      }}
                                    >
                                      <div>{"No Record Found..."}</div>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <hr className="mt-1 mb-1"></hr>
                    <Row>
                      <Col lg={3}>
                        <Field
                          label="Customer"
                          name="WAMsscCustomerIDEncrypted"
                          placeholder={"Select Customer"}
                          loadOptionsFn={loadOptionsCustomer_SSC}
                          component={CustomSelectAsync}
                          title={WAMsscCustomerName}
                          labelFieldName="WAMsscCustomerName"
                          menuPosition="fixed"
                        />
                      </Col>
                      <Col lg={3}>
                        <Field
                          label="Contact Person"
                          name="WAMsscCustomerContactPersonIDEncrypted"
                          placeholder={"Select Contact Person"}
                          options={sscContactPersonOptions}
                          component={CustomSelect}
                          menuPosition="fixed"
                          onChange={(e) => {
                            formikWhatsAppMessageSendScanCopy.setFieldValue(
                              "WAMsscCustomerContactPersonIDEncrypted",
                              e?.value ?? ""
                            );
                            formikWhatsAppMessageSendScanCopy.setFieldValue(
                              "WAMsscContactPerson",
                              e?.label ?? ""
                            );
                            formikWhatsAppMessageSendScanCopy.setFieldValue(
                              "WAMsscDesignation",
                              e?.Designation ?? ""
                            );
                            formikWhatsAppMessageSendScanCopy.setFieldValue(
                              "WAMsscMobileNo",
                              e?.MobileNo ?? ""
                            );
                            formikWhatsAppMessageSendScanCopy.setFieldValue(
                              "WAMsscEmailID",
                              e?.EmailID ?? ""
                            );
                            formikWhatsAppMessageSendScanCopy.setFieldValue(
                              "WAMsscContactPersonID",
                              e?.ContactPersonID ?? ""
                            );
                          }}
                        />
                      </Col>
                      <Col lg={3}>
                        <div className="mb-2">
                          <label className="mb-1">&nbsp;</label>
                          <div>
                            <button
                              type="button"
                              // className="btn btn-primary btn-sm "
                              className="btn btn-outline-primary btn-sm"
                              onClick={(e) => {
                                addAdditionalContactPerson_SSC_WAM();
                              }}
                            >
                              + Add
                            </button>
                          </div>
                        </div>
                      </Col>
                      <Col lg={12}>
                        <div className="table-responsive active-projects style-1 shorting">
                          <div
                            id="AdditionalContactPerson-tbl_wrapper"
                            className="dataTables_wrapper no-footer"
                          >
                            <table
                              id="AdditionalContactPerson-tbl"
                              className="table dataTable no-footer"
                            >
                              <thead>
                                <tr>
                                  <th style={{ width: "3%" }}></th>
                                  <th style={{ width: "3%" }}></th>
                                  <th style={{ width: "24%" }}>
                                    Customer Name
                                  </th>
                                  <th style={{ width: "20%" }}>
                                    Contact Person
                                  </th>
                                  <th style={{ width: "20%" }}>Designation</th>
                                  <th style={{ width: "15%" }}>Mobile No</th>
                                  <th
                                    style={{ width: "15%", textAlign: "left" }}
                                  >
                                    Email
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {WAMsscListOfAdditionalContactPerson?.length >
                                0 ? (
                                  WAMsscListOfAdditionalContactPerson?.filter(
                                    (x) => x.MobileNo !== ""
                                  ).map((item, idx) => (
                                    // WAMsscListOfAdditionalContactPerson?.map(
                                    //   (item, idx) => (
                                    <tr>
                                      <td>{idx + 1}</td>
                                      <td>
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          id="checkIsSelectedACP"
                                          checked={item?.IsSelected}
                                          onChange={() => {
                                            formikWhatsAppMessageSendScanCopy.setFieldValue(
                                              `WAMsscListOfAdditionalContactPerson[${idx}].IsSelected`,
                                              !item?.IsSelected
                                            );
                                          }}
                                          style={{ cursor: "pointer" }}
                                        ></input>
                                      </td>
                                      <td>{item?.CustomerName}</td>
                                      <td>{item?.ContactPerson}</td>
                                      <td>{item?.Designation}</td>
                                      <td>{item?.MobileNo}</td>
                                      <td style={{ textAlign: "left" }}>
                                        {item?.EmailID}
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td
                                      colSpan={7}
                                      style={{
                                        textAlign: "left",
                                      }}
                                    >
                                      <div>{"No Record Found..."}</div>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={6}>
                        <Field
                          //type="number"
                          label="Additional Mobile No"
                          name="WAMsscAdditionalMobileNo"
                          placeholder={
                            "Enter Additional Mobile No like 1234567890,0987654321"
                          }
                          component={CustomInput}
                        />
                      </Col>
                    </Row>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="primary btn-sm" type="submit">
                      <i className="fab la-whatsapp me-2" /> Send Message
                    </Button>
                    <Button
                      variant="danger btn-sm"
                      onClick={() =>
                        setShowWhatsAppMessageSendScanCopyModal(false)
                      }
                    >
                      <i className="fa fa-cancel"></i> Cancel
                    </Button>
                  </Modal.Footer>
                </Form>
              </FormikProvider>
            </Spin>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default UploadScanCopy;
